// extracted by mini-css-extract-plugin
export default {"tupacGrid":"zn-z","tupacHeader":"An-z","tupacHeader2":"Bn-z","tupacMenu":"Cn-z","tupacMenu2":"Dn-z","tupacMain":"En-z","tupacMain2":"Fn-z"};